import { ChartRowDataArray } from "../constants";

/**
 * チャートデータのStep数を取得します
 * @param {number} count - データ件数
 * @param {number} threshold - 間引き閾値
 * @returns {number} Step数
 */
function getStep(count: number, threshold: number): number {
  const ceil = threshold > 0 ? Math.ceil(count / threshold) : 1;
  return ceil < 1 ? 1 : ceil;
}

/**
 * 間引きしたデータを作成します
 * @param {ChartRowDataArray} rows - １行配列
 * @param {number} step - Step数
 * @param {boolean} includeEnd - 終端を含める場合はtrue,それ以外の場合はfalse
 * @returns 間引き後データ
 */
function createThinningData(
  rows: ChartRowDataArray,
  step: number,
  includeEnd: boolean
): ChartRowDataArray {
  const datalist: ChartRowDataArray = [];
  datalist.push([...rows[0]]);
  let i = 1;
  for (; i < rows.length; i += step) {
    datalist.push([...rows[i]]);
  }
  if (includeEnd && i >= rows.length) {
    const end = rows.length - 1;
    datalist.push([...rows[end]]);
  }
  return datalist;
}

export function createRowData(
  rows: ChartRowDataArray,
  threshold: number,
  includeEnd: boolean
): ChartRowDataArray {
  const step = getStep(rows.length - 1, threshold);
  if (step > 1) {
    const thinningdata = createThinningData(rows, step, includeEnd);
    const end = thinningdata.length - 1;
    if (thinningdata[end - 1].toString() === thinningdata[end].toString()) {
      thinningdata.pop();
    }
    return thinningdata;
  } else {
    return rows;
  }
}

export function ProjaectName(name: string): string {
  return name.replaceAll("”", "").replaceAll('"', "");
}

export function ProjaectMemo(memo: string): string {
  return ProjaectName(memo);
}

export function FileName(name: string): string {
  return ProjaectName(name);
}

export function SerialMemo(memo: string): string {
  return ProjaectName(memo);
}

export function MacaddrMemo(memo: string): string {
  return ProjaectName(memo);
}

/**
 * 桁数を0埋めした日時を作成します
 * @param {Date} datetime - 日時
 * @returns 0埋めした日時
 */
 export function toLocaleString(datetime: Date): string {
  const year = datetime.getFullYear();
  const month = datetime.getMonth() + 1;
  const day = datetime.getDate();
  const hour = datetime.getHours();
  const minute = datetime.getMinutes();
  const second = datetime.getSeconds();
  return (
    year +
    "/" +
    month.toString().padStart(2, "0") +
    "/" +
    day.toString().padStart(2, "0") +
    " " +
    hour.toString().padStart(2, "0") +
    ":" +
    minute.toString().padStart(2, "0") +
    ":" +
    second.toString().padStart(2, "0")
  );
}
